import React from 'react';
import { Notification } from '@mafc/trolly';
import COLORS from 'theme/colors';

import { notificationTypes } from './redux/notification.type';

interface IProps {
  nonClosable?: boolean;
  type?: notificationTypes;
  children?: React.ReactNode;
}
const NotifcationLayout: React.FC<IProps> = props => {
  const { nonClosable = false, type = notificationTypes.errorCheckout, children } = props;

  const BORDER_COLOR: { [key: string]: string } = {
    success: COLORS.GREEN,
    errorCheckout: COLORS.RED,
  };

  return (
    <Notification
      nonClosable={nonClosable}
      border={`0`}
      borderTop={`3px solid ${BORDER_COLOR[type] || ''}`}
    >
      {children}
    </Notification>
  );
};

export default NotifcationLayout;
